/**
 * OnboardingStatus Value Object
 * Represents the current state of onboarding progress
 */
export type OnboardingStatus = 'pending' | 'in_progress' | 'completed' | 'skipped';

export const OnboardingStatusValues = {
  PENDING: 'pending' as OnboardingStatus,
  IN_PROGRESS: 'in_progress' as OnboardingStatus,
  COMPLETED: 'completed' as OnboardingStatus,
  SKIPPED: 'skipped' as OnboardingStatus,
} as const;

/**
 * Type guard to validate OnboardingStatus
 */
export function isValidOnboardingStatus(value: string): value is OnboardingStatus {
  return ['pending', 'in_progress', 'completed', 'skipped'].includes(value);
}
